import classNames from 'classnames'
import moment from 'moment'
import { useState } from 'react'

import { Icon } from '@/shared'
import { EIcons } from '@App/types/iconType'

import style from './Dates.module.scss'

interface IProps {
    dates: string[]
    isFetching: boolean
    onGetPriceDataByDate: (date: string) => void
}

export const Dates = (props: IProps) => {
    const { dates, isFetching, onGetPriceDataByDate } = props

    const [collapsed, setCollapsed] = useState<boolean>(false)

    return (
        <div className={style.container}>
            <div className={style.titleWrapper} onClick={() => setCollapsed(!collapsed)}>
                <div className={style.title}>
                    <span>Даты активации</span>
                </div>
                <div className={style.icon}>
                    <Icon iconName={EIcons.AROW} />
                </div>
            </div>
            {dates.length > 0 && (
                <div className={classNames(style.datesWrapper, !collapsed && style.datesWrapperCollapsed)}>
                    {dates.map((date, idx) => {
                        const onClickHandler = () => {
                            if (!isFetching) {
                                onGetPriceDataByDate(date)
                            }
                        }
                        return (
                            <div
                                key={idx}
                                onClick={onClickHandler}
                                className={classNames(style.date, isFetching && style.fetchedDate)}
                            >
                                <span>{moment(date).format('DD.MM.YYYY')}</span>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}
